import React, { Component } from "react";
import leftArrow from "../assets/pink-back.svg";

export default class BackArrow extends Component {
  render() {
    return (
      <button
        onClick={
          this.props.backFunction ? this.props.backFunction : window.goBack
        }
        className={"bk-btn " + this.props.className}
      >
        <img src={leftArrow} alt="" />
      </button>
    );
  }
}
